module.exports = __webpack_public_path__ + "static/media/photo153.307d0e28.jpg";